import { hasValue } from 'src/packages/utils/has-value';
import { isObjectWithKeys } from 'src/packages/utils/is-object-with-keys';

import type { TComboboxOptionsConcatinationRule } from '../mappers';
import type { IDirectoriesStorage } from 'src/services/directories-storage-service/directories-storage-service';

import { handleValueSourceRule } from './handle-value-source-rule';

/** Это правило не вызывается как остальные в main-directory-service при изменении значения поля (по крайней мере пока что) и используется только в options-service */
export const handleComboboxOptionsConcatinationRule = (
  directories: IDirectoriesStorage,
  record: Record<string, unknown>,
  rule: TComboboxOptionsConcatinationRule,
): { value: string } => {
  const value = handleValueSourceRule(directories, record, rule.ruleView.value.sources)?.valuesByPseudonims;

  if (!value) {
    return { value: '-' };
  }

  if (rule.ruleView.template && isObjectWithKeys(value)) {
    return { value: getValueByTemplate(rule.ruleView.template, value) };
  }

  const values = Object.values(value).filter((v) => hasValue(v));

  if (!Array.isArray(values) && hasValue(values)) {
    console.error('value is not array', value);
    return { value: '-' };
  }

  return { value: values.join(rule.ruleView.delimiter ?? ' / ') };
};

const getValueByTemplate = (template: string, pseudonims: Record<string, unknown>): string => {
  return template.replaceAll(/{.+?}/g, (match) => {
    const cleanPseudonim = match.slice(1, match.length - 1);

    return String(pseudonims[cleanPseudonim] ?? '-');
  });
};
